import { render, staticRenderFns } from "./FormRsvpRecipientDialog.vue?vue&type=template&id=13376526&scoped=true"
import script from "./FormRsvpRecipientDialog.vue?vue&type=script&lang=js"
export * from "./FormRsvpRecipientDialog.vue?vue&type=script&lang=js"
import style0 from "./FormRsvpRecipientDialog.vue?vue&type=style&index=0&id=13376526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13376526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDivider,VExpandTransition,VForm,VIcon,VTextField})
